import { Box, Typography } from "@mui/material";
import { MouseEvent, ReactNode } from "react";
import { useTranslation } from "react-i18next";
import DocsIcon from "../../../../assets/Dashboard/icons/DocsIcon";
import BriaButtonGroup from "../../../../components/common/BriaButtonGroup/BriaButtonGroup";
import BriaIconButton from "../../../../components/common/BriaIconButton/BriaIconButton";
import styles from "./ProductsWidgetCards.module.scss";

type ProductsWidgetCardsProps = {
	cards: ProductsWidgetCardProps[];
};

const ProductsWidgetCards = ({ cards }: ProductsWidgetCardsProps) => {
	return (
		<Box className={styles.container}>
			<Box className={styles.cards}>
				{cards.map((card) => (
					<ProductsWidgetCard {...card} />
				))}
			</Box>
		</Box>
	);
};

export default ProductsWidgetCards;

export type ProductsWidgetCardProps = {
	icon: ReactNode;
	header: string;
	description: string;
	docsLink: string;
	comingSoonBadge?: boolean;
	onClick?: () => void;
};

const ProductsWidgetCard = ({
	icon,
	header,
	description,
	docsLink,
	comingSoonBadge,
	onClick,
}: ProductsWidgetCardProps) => {
	const { t } = useTranslation("dashboard", { keyPrefix: "products.cards" });

	const openDocs = (e: MouseEvent) => {
		e.stopPropagation();
		window.open(docsLink, "_blank");
	};

	return (
		<Box className={`${styles.card} ${onClick ? styles.clickableCard : ""}`} onClick={onClick}>
			<BriaButtonGroup className={styles.iconButtons}>
				{comingSoonBadge && <Typography className={styles.badge}>{t("comingSoonBadge")}</Typography>}
				{docsLink && (
					<BriaIconButton className={styles.iconBtn} title={t("docsTooltip")} onClick={openDocs} disabled={comingSoonBadge}>
						<DocsIcon className={styles.svgIcon} />
					</BriaIconButton>
				)}
			</BriaButtonGroup>
			<Box className={styles.header}>
				{icon}
				<Typography className={styles.title}>{header}</Typography>
			</Box>
			<Typography className={styles.description}>{description}</Typography>
		</Box>
	);
};
